import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppSettings } from 'src/app/app-settings';
import { fixedPassFromLabel, isFixedPricePass } from 'src/app/utils/fixed-price-pass.util';

@Component({
  selector: 'app-pass-select-dialog',
  templateUrl: './pass-select-dialog.component.html',
  styleUrls: ['./pass-select-dialog.component.scss']
})
export class PassSelectDialogComponent implements OnInit {

  passes: any[] = [];
  selectedPass: any = null;
  quantity: number = 1;
  urlImages: string = AppSettings.MEDIA_URI + '/events_images/';

  constructor(
    private dialogRef: MatDialogRef<PassSelectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { passes: any[] }
  ) {}

  ngOnInit(): void {
    this.passes = this.data?.passes || [];
    if (this.passes.length === 1) {
      this.selectedPass = this.passes[0];
    }
  }

  selectPass(pass: any) {
    this.selectedPass = pass;
  }

  getDiscountBadge(pass: any): string {
    if (isFixedPricePass(pass)) return fixedPassFromLabel(pass);
    if (pass.discount_mode === 'percentage') return `${Math.trunc(pass.discount_value)}% dto.`;
    if (pass.discount_mode === 'fixed') return `-${pass.discount_value}€`;
    return '';
  }

  getEventCount(pass: any): number {
    if (pass.pass_items?.length) {
      const uniqueEventIds = new Set(pass.pass_items.map((i: any) => i.event_id ?? i.event?.id).filter(Boolean));
      return uniqueEventIds.size;
    }
    if (pass.min_events) return pass.min_events;
    return 0;
  }

  increaseQty() {
    if (this.quantity < 10) this.quantity++;
  }

  decreaseQty() {
    if (this.quantity > 1) this.quantity--;
  }

  confirm() {
    if (!this.selectedPass) return;
    this.dialogRef.close({ pass: this.selectedPass, quantity: this.quantity });
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
